const MIKA_LOCALE_KEY = 'mika.locale';
const MIKA_LOCALE_SWITCHING_KEY = 'mk-locale-switching';

function localeCssMs(name, fallback) {
    const declared = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue(name),
        10
    );

    return isNaN(declared) ? fallback : declared;
}

function isSupportedLocale(value) {
    return value === 'en' || value === 'de';
}

function readLocalePreference() {
    try {
        const value = localStorage.getItem(MIKA_LOCALE_KEY);

        if (value === null) {
            return null;
        }

        return isSupportedLocale(value) ? value : null;
    } catch (e) {
        return undefined;
    }
}

function saveLocalePreference(value) {
    if (!isSupportedLocale(value)) return;

    try {
        localStorage.setItem(MIKA_LOCALE_KEY, value);
    } catch (e) {
        return;
    }
}

function browserLocale() {
    const languages = Array.isArray(navigator.languages) && navigator.languages.length
        ? navigator.languages
        : [navigator.language];

    for (const language of languages) {
        if (typeof language !== 'string') continue;

        const locale = language.toLowerCase().split('-')[0];
        if (isSupportedLocale(locale)) {
            return locale;
        }
    }

    return null;
}

function isNeutralLocaleEntry() {
    return document.documentElement.dataset.localeEntryEligible === 'true';
}

function isSameOriginPath(value) {
    return typeof value === 'string'
        && value.startsWith('/')
        && !value.startsWith('//')
        && !value.includes('\\');
}

function pathForLocale(value) {
    const contract = document.documentElement.dataset;
    const currentLocale = contract.locale;

    if (!isSupportedLocale(value) || !isSupportedLocale(currentLocale)) return null;
    if (value === currentLocale) return null;
    if (contract.localeCounterpartAvailable !== 'true') return null;
    if (!isSameOriginPath(contract.localeCounterpartUrl)) return null;

    return contract.localeCounterpartUrl;
}

function counterpartUrlFor(oppositeLocale) {
    const hook = document.querySelector(
        '.gh-locale-counterpart[data-locale-counterpart-locale="' + oppositeLocale + '"]'
    );

    if (hook && hook.dataset.localeCounterpartPath) {
        return hook.dataset.localeCounterpartPath;
    }

    const alternateLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
    for (var i = 0; i < alternateLinks.length; i++) {
        if (alternateLinks[i].getAttribute('hreflang') === oppositeLocale) {
            return alternateLinks[i].getAttribute('href');
        }
    }

    return null;
}

function applyCounterpartUrl() {
    const doc = document.documentElement;
    const currentLocale = doc.dataset.locale;

    if (!isSupportedLocale(currentLocale)) return;

    const oppositeLocale = currentLocale === 'en' ? 'de' : 'en';
    const counterpartUrl = counterpartUrlFor(oppositeLocale);

    var switcherLinks = document.querySelectorAll('[data-locale-choice="' + oppositeLocale + '"]');
    if (!switcherLinks.length) return;

    if (!counterpartUrl) {
        doc.dataset.localeCounterpartAvailable = 'false';
        return;
    }

    for (var i = 0; i < switcherLinks.length; i++) {
        switcherLinks[i].setAttribute('href', counterpartUrl);
    }

    doc.dataset.localeCounterpartAvailable = 'true';

    if (isSameOriginPath(counterpartUrl)) {
        doc.dataset.localeCounterpartUrl = counterpartUrl;
    }
}

function locale() {
    var localeLinks = document.querySelectorAll('[data-locale-choice]');
    var switching = false;

    for (var i = 0; i < localeLinks.length; i++) {
        localeLinks[i].addEventListener('click', function (event) {
            var link = event.currentTarget;

            saveLocalePreference(link.dataset.localeChoice);

            /* Everything below is the cross-fade, and every guard here is a way
               of letting the anchor just be an anchor: a middle-click or a
               modified click still opens a tab, reduced motion still navigates
               flat, and with no JavaScript at all none of this exists. Same
               contract the work arrow keeps. */
            if (event.defaultPrevented || event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            if (switching) return;

            event.preventDefault();
            switching = true;

            /* The note the arriving document reads pre-paint to fade its own
               language in. Without it the new page simply arrives at full
               opacity, which is the old behaviour, not a broken one. */
            try {
                sessionStorage.setItem(MIKA_LOCALE_SWITCHING_KEY, '1');
            } catch (e) {
                // Private mode; the switch loses its second half and nothing else.
            }

            document.documentElement.classList.add('is-locale-leaving');

            // One timer off the declared duration keeps CSS and JS honest,
            // rather than listening for one of several animationends.
            window.setTimeout(function () {
                window.location.href = link.href;
            }, localeCssMs('--locale-fade-out-ms', 150) + 20);
        });
    }

    /* Coming back to a faded-out page from the bfcache would otherwise restore
       it mid-fade and leave it there — the leaving animation fills forwards. */
    window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;

        switching = false;
        document.documentElement.classList.remove('is-locale-leaving');
    });

    applyCounterpartUrl();

    if (!isNeutralLocaleEntry()) return;

    const savedLocale = readLocalePreference();
    if (savedLocale === undefined) return;

    const requestedLocale = savedLocale || browserLocale();
    const target = pathForLocale(requestedLocale);
    if (!target) return;

    location.replace(target);
}
